import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _b75937ee = () => interopDefault(import('..\\pages\\configuration\\index.vue' /* webpackChunkName: "pages/configuration/index" */))
const _4af7dbaa = () => interopDefault(import('..\\pages\\dashboard\\index.vue' /* webpackChunkName: "pages/dashboard/index" */))
const _73d6ab35 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _3d7e4e4c = () => interopDefault(import('..\\pages\\login.vue' /* webpackChunkName: "pages/login" */))
const _8146f892 = () => interopDefault(import('..\\pages\\logout.vue' /* webpackChunkName: "pages/logout" */))
const _d8c6de5c = () => interopDefault(import('..\\pages\\payouts\\index.vue' /* webpackChunkName: "pages/payouts/index" */))
const _7750299a = () => interopDefault(import('..\\pages\\sales\\index.vue' /* webpackChunkName: "pages/sales/index" */))
const _b2006412 = () => interopDefault(import('..\\pages\\spiffplans\\index.vue' /* webpackChunkName: "pages/spiffplans/index" */))
const _5088e1c0 = () => interopDefault(import('..\\pages\\cms\\components\\index.vue' /* webpackChunkName: "pages/cms/components/index" */))
const _0cf39a3c = () => interopDefault(import('..\\pages\\cms\\contents\\index.vue' /* webpackChunkName: "pages/cms/contents/index" */))
const _c0bbc98a = () => interopDefault(import('..\\pages\\cms\\components\\_componentId.vue' /* webpackChunkName: "pages/cms/components/_componentId" */))
const _2d6f497b = () => interopDefault(import('..\\pages\\cms\\contents\\_contentId.vue' /* webpackChunkName: "pages/cms/contents/_contentId" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/configuration",
    component: _b75937ee,
    name: "configuration___en"
  }, {
    path: "/dashboard",
    component: _4af7dbaa,
    name: "dashboard___en"
  }, {
    path: "/fr",
    component: _73d6ab35,
    name: "index___fr"
  }, {
    path: "/login",
    component: _3d7e4e4c,
    name: "login___en"
  }, {
    path: "/logout",
    component: _8146f892,
    name: "logout___en"
  }, {
    path: "/payouts",
    component: _d8c6de5c,
    name: "payouts___en"
  }, {
    path: "/sales",
    component: _7750299a,
    name: "sales___en"
  }, {
    path: "/spiffplans",
    component: _b2006412,
    name: "spiffplans___en"
  }, {
    path: "/cms/components",
    component: _5088e1c0,
    name: "cms-components___en"
  }, {
    path: "/cms/contents",
    component: _0cf39a3c,
    name: "cms-contents___en"
  }, {
    path: "/fr/configuration",
    component: _b75937ee,
    name: "configuration___fr"
  }, {
    path: "/fr/dashboard",
    component: _4af7dbaa,
    name: "dashboard___fr"
  }, {
    path: "/fr/login",
    component: _3d7e4e4c,
    name: "login___fr"
  }, {
    path: "/fr/logout",
    component: _8146f892,
    name: "logout___fr"
  }, {
    path: "/fr/payouts",
    component: _d8c6de5c,
    name: "payouts___fr"
  }, {
    path: "/fr/sales",
    component: _7750299a,
    name: "sales___fr"
  }, {
    path: "/fr/spiffplans",
    component: _b2006412,
    name: "spiffplans___fr"
  }, {
    path: "/fr/cms/components",
    component: _5088e1c0,
    name: "cms-components___fr"
  }, {
    path: "/fr/cms/contents",
    component: _0cf39a3c,
    name: "cms-contents___fr"
  }, {
    path: "/",
    component: _73d6ab35,
    name: "index___en"
  }, {
    path: "/fr/cms/components/:componentId",
    component: _c0bbc98a,
    name: "cms-components-componentId___fr"
  }, {
    path: "/fr/cms/contents/:contentId",
    component: _2d6f497b,
    name: "cms-contents-contentId___fr"
  }, {
    path: "/cms/components/:componentId",
    component: _c0bbc98a,
    name: "cms-components-componentId___en"
  }, {
    path: "/cms/contents/:contentId",
    component: _2d6f497b,
    name: "cms-contents-contentId___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
